"use strict";

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SskyStepper = void 0;

const material_1 = require("@mui/material");

const classnames_1 = __importDefault(require("classnames"));

const react_1 = __importDefault(require("react"));

const DEFAULT_BASE_FONT_SIZE = 16;
const StyledStepper = (0, material_1.styled)(material_1.Stepper, {
  shouldForwardProp: prop => prop !== "stepperStyle"
})(({
  stepperStyle
}) => ({
  [`&.${material_1.stepperClasses.root}`]: Object.assign({}, stepperStyle)
})); // the hardcoded numbers used for calculating the styles-default-font-size are taken from the material-ui style-default-font-size ratio

const StyledStepLabel = (0, material_1.styled)(material_1.StepLabel, {
  shouldForwardProp: prop => prop !== "stepStyle" && prop !== "baseFontSize"
})(({
  stepStyle,
  baseFontSize
}) => ({
  [`&.${material_1.stepLabelClasses.label}`]: Object.assign({
    fontSize: 0.875 * (baseFontSize || DEFAULT_BASE_FONT_SIZE)
  }, stepStyle === null || stepStyle === void 0 ? void 0 : stepStyle.label),
  [`& .${material_1.stepIconClasses.root}`]: Object.assign({
    fontSize: 1.5 * (baseFontSize || DEFAULT_BASE_FONT_SIZE)
  }, stepStyle === null || stepStyle === void 0 ? void 0 : stepStyle.iconRoot),
  [`& .${material_1.stepIconClasses.text}`]: Object.assign({
    fontSize: 0.75 * (baseFontSize || DEFAULT_BASE_FONT_SIZE)
  }, stepStyle === null || stepStyle === void 0 ? void 0 : stepStyle.iconText)
}));

const SskyStepper = props => {
  var _a, _b, _c, _d;

  const stepContent = (_c = (_b = (_a = props.steps[props.activeStepIndex]) === null || _a === void 0 ? void 0 : _a.render) === null || _b === void 0 ? void 0 : _b.call(_a)) !== null && _c !== void 0 ? _c : null;
  return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(StyledStepper, {
    nonLinear: (_d = props.nonLinear) !== null && _d !== void 0 ? _d : true,
    activeStep: props.activeStepIndex,
    className: (0, classnames_1.default)("ssky-stepper", props.className),
    stepperStyle: props.stepperStyle
  }, props.steps.map((item, index) => {
    return react_1.default.createElement(material_1.Step, {
      disabled: item.disabled,
      key: index,
      "data-testid": item.dataTestId || `testId-${item.label}`
    }, react_1.default.createElement(material_1.StepButton, {
      onClick: () => props.onStepChange(index)
    }, react_1.default.createElement(StyledStepLabel, {
      stepStyle: props.stepStyle,
      baseFontSize: props.baseFontSize
    }, item.label)));
  })), stepContent);
};

exports.SskyStepper = SskyStepper;
exports.default = react_1.default.memo(SskyStepper);